"use strict";

import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import RegisterEmailFormInput from "./RegisterEmailFormInput";
import formInputErrorClassName from "../../formInputErrorClassName";

const RegisterEmailForm = ({data={}, onSubmit=()=>{}, onCancel=()=>{}, emailIsUnique=()=>{}, children}) => {
    const { register, handleSubmit, control, getValues, reset, formState: { errors, isValidating, },} = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onSubmit',
        defaultValues: data,
    });

    function formInputClassName(name = '') {
        return formInputErrorClassName(name, errors);
    }

    function handleCancelClick(e){
        e.preventDefault();
        reset();
        onCancel();
    }

    return (
        <form id="echeck__register__email__form"
              className="echeck__register__email__form"
              style={{position: 'relative'}}
              onSubmit={handleSubmit(onSubmit)} noValidate >
            <RegisterEmailFormInput data={data}
                                     register={register}
                                     control={control}
                                     errors={errors}
                                     isValidating={isValidating}
                                     getValues={getValues}
                                     emailIsUnique={emailIsUnique}
                                     formInputClassName={formInputClassName} />
            {children}
        </form>
    );
};

export default RegisterEmailForm;
